var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAioaIconType5(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 132,
    height: 132,
    viewBox: "0 0 132 132",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1129 -316)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(1129 316)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 10
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 66,
    cy: 66,
    r: 66,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 66,
    cy: 66,
    r: 61,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M19.791,76.982V48.8H18.164V76.977a4.479,4.479,0,0,1-4.173,4.437q-.206.019-.416.019a4.487,4.487,0,0,1-4.522-4.451V37.252L8.639,25.6a6.665,6.665,0,0,0-.989,1.308c-.921,1.576-1.8,4.4-1.8,9.187A70.921,70.921,0,0,0,7.738,50.908a2.88,2.88,0,0,1-2.247,3.42,2.963,2.963,0,0,1-.615.065,2.916,2.916,0,0,1-2.859-2.276A76.511,76.511,0,0,1,0,36.1a29.1,29.1,0,0,1,1.2-8.912A12.491,12.491,0,0,1,6.32,20.091a9.619,9.619,0,0,1,4.653-1.446c.169-.009.324-.013.464-.013l.141,0c.049-.006.1-.01.148-.013.074-.006.148-.01.222-.01H26.075a2.817,2.817,0,0,1,.361.026c.066,0,.13,0,.2,0a9.571,9.571,0,0,1,5,1.454,12.492,12.492,0,0,1,5.121,7.092,29.089,29.089,0,0,1,1.2,8.911,76.511,76.511,0,0,1-2.017,16.02,2.918,2.918,0,0,1-2.859,2.277,2.963,2.963,0,0,1-.615-.065A2.881,2.881,0,0,1,30.218,50.9,70.914,70.914,0,0,0,32.1,36.09c0-4.788-.878-7.61-1.8-9.186a6.657,6.657,0,0,0-.988-1.308L28.9,37.257V76.977a4.48,4.48,0,0,1-4.173,4.437q-.206.018-.416.019A4.487,4.487,0,0,1,19.791,76.982ZM17.184,16.043a8.439,8.439,0,0,1-1.359-.444A7.979,7.979,0,0,1,10.8,8.831a8.056,8.056,0,0,1,.167-2.624A8.166,8.166,0,0,1,20.85.157a8.253,8.253,0,0,1,6.214,9.837,8.137,8.137,0,0,1-7.957,6.274A8.376,8.376,0,0,1,17.184,16.043Z",
    transform: "translate(1176 341.066)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAioaIconType5);
export default __webpack_public_path__ + "static/media/aioa-icon-type-5.66e15d3462e7b0e6cac6f8eb662f0617.svg";
export { ForwardRef as ReactComponent };